<template>
  <SectionPageShell section="support" title="Ticket erstellen" show-back-link>
    <Form
      @submit="submit"
      v-slot="{ errors }"
      :validation-schema="schema"
      :initial-values="initialValues"
      ref="supportForm"
    >
      <fieldset class="fieldset">
        <div class="mb-3">
          <label class="form-label" for="support-title">Titel</label>
          <Field
            type="text"
            id="support-title"
            name="title"
            class="form-control"
            :class="{ 'is-invalid': errors.title }"
            placeholder="Titel des Tickets"
          />
          <ErrorMessage name="title" class="mt-1 d-block invalid-feedback" />
        </div>

        <div class="mb-3">
          <label class="form-label" for="support-message">Nachricht</label>
          <Field
            as="textarea"
            id="support-message"
            name="message"
            class="form-control"
            :class="{ 'is-invalid': errors.message }"
            placeholder="Beschreiben Sie Ihr Anliegen"
          />
          <ErrorMessage name="message" class="mt-1 d-block invalid-feedback" />
        </div>

        <button type="submit" class="btn btn-warning">
          Ticket absenden
        </button>
      </fieldset>
    </Form>
  </SectionPageShell>
</template>

<script>
import SectionPageShell from "@/components/base_type/SectionPageShell.vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import Yup from "@/yup";
import { useSupportStore } from "@/stores/support";
import { useUserStore } from "@/stores/user";
import { Helpers } from "@/helpers";

export default {
  name: "SupportCreatePage",
  components: {
    ErrorMessage,
    Field,
    Form,
    SectionPageShell,
  },
  setup() {
    return {
      supportStore: useSupportStore(),
      userStore: useUserStore(),
    }
  },
  data() {
    return {
      schema: Yup.object({
        title: Yup.string().required(),
        message: Yup.string().required().label('Nachricht'),
      }),
    }
  },
  computed: {
    initialValues() {
      return {
        title: String(this.$route.query.title || ''),
        message: '',
      }
    },
  },
  methods: {
    submit(values) {
      this.supportStore.create(values).then(() => {
        Helpers.emitter.emit('success', 'Ticket erstellt. Leite weiter...')
        setTimeout(() => {
          this.$router.push({ name: 'account.support' })
        }, 3000)
      }).catch(({ response }) => {
        this.$refs.supportForm.setErrors(response?.data || {})
      })
    },
  },
}
</script>
<style scoped lang="scss">
#support-message {
  min-height: 10rem;
}
</style>
